import i18n from '@/vendors/i18n'
import { useCurrencyStore } from '@/stores/CurrencyStore'

export default {
  name: 'project_currency',
  model: 'actions_data.project.currency',
  type: 'input_select',
  settings: {
    icon: 'currency',
    category: 'project_fields',
    require_model: true,
    options: () => {
      const { activeCurrencies } = useCurrencyStore()

      return activeCurrencies.map(currency => ({ text: i18n.getLocalesTranslations(`currencies.${currency.toLowerCase()}_label`), value: currency }))
    }
  },
  content: {
    title: i18n.getLocalesTranslations('$procedure_block.name_id_project_currency')
  },
  components: [
    {
      path: 'molecules/ModuleInputText',
      model: 'attributes.label',
      value: i18n.getLocalesTranslations('$block.project_currency_label'),
      content: {
        label: i18n.getLocalesTranslations('literal.question')
      }
    },
    {
      path: 'molecules/ModuleInputCheckboxMandatory',
      value: 'required',
      content: {
        label: i18n.getLocalesTranslations('$procedure_block.label_is_mandatory')
      }
    }
  ],
  is_allowed: {
    'procedure.actions': ['project'],
    'client.is_multi_currency': true
  }
}
